import { useEffect } from 'react';

declare global {
  interface Window {
    zE?: (action: string, command: string, ...args: any[]) => void;
  }
}

export function getZendeskKey() {
  return process.env.NEXT_PUBLIC_ZENDESK_KEY;
}

export function isZendeskEnabled() {
  return process.env.NODE_ENV === 'production' && !!getZendeskKey();
}

export function openZendeskChat() {
  if (!window.zE) {
    return
  }
  window.zE('messenger', 'show');
  window.zE('messenger', 'open');
}

export function useHideZendeskChat() {
  useEffect(() => {
    if (!isZendeskEnabled()) return;
    if (window.zE) window.zE('messenger', 'hide');
  }, []);
}
